import { EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { Clipping } from 'src/app/components/image/model';
import { FixedAspectRatioImageDTO, SingleFileUpload } from '../../api/api';

export class ImageUploadTransfer {
  public clippingChange: EventEmitter<Clipping> = new EventEmitter<Clipping>();
  public fileChange: EventEmitter<SingleFileUpload> = new EventEmitter<SingleFileUpload>();
  public deletePress: EventEmitter<void> = new EventEmitter<void>();
  public image: FixedAspectRatioImageDTO;
  public uploading: boolean;
  public modalClosed: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}
}

export class ImageUploadModel {
  public imageTransfer: ImageUploadTransfer = null;
  public subClippingChange: Subscription = null;
  public subFileChange: Subscription = null;
  public subDeletePress: Subscription = null;
  public subModalClosed: Subscription = null;

  public destroySubscriptions(): void {
    this.destroySubscription(this.subClippingChange);
    this.subClippingChange = null;
    this.destroySubscription(this.subFileChange);
    this.subFileChange = null;
    this.destroySubscription(this.subDeletePress);
    this.subDeletePress = null;
    this.destroySubscription(this.subModalClosed);
    this.subModalClosed = null;

    this.imageTransfer = null;
  }

  private destroySubscription(sub?: Subscription) {
    try {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    } catch (err) {
      console.log(err);
    }
  }
}
